import { type ComponentType, type ReactNode, type SVGProps } from 'react'
import { BoxLogo, DropboxLogo, GoogleDriveLogo, OneDriveLogo } from '@/assets/icons'
import { kExternalStorageProvider, kExternalStorageProviderDisplayName, type ExternalStorageProvider } from '@/constants/constants-external-storage'

export const PROVIDER_ICON_COMPONENTS: Record<ExternalStorageProvider, ComponentType<SVGProps<SVGSVGElement>>> = {
  [kExternalStorageProvider.GOOGLE_DRIVE]: GoogleDriveLogo,
  [kExternalStorageProvider.DROPBOX]: DropboxLogo,
  [kExternalStorageProvider.BOX]: BoxLogo,
  [kExternalStorageProvider.ONEDRIVE]: OneDriveLogo,
}

export const PROVIDER_META: Record<ExternalStorageProvider, { label: string; icon: ReactNode; modalIcon: ReactNode }> = {
  [kExternalStorageProvider.GOOGLE_DRIVE]: {
    label: kExternalStorageProviderDisplayName[kExternalStorageProvider.GOOGLE_DRIVE],
    icon: <GoogleDriveLogo className="h-[30px] w-[33px] shrink-0" />,
    modalIcon: <GoogleDriveLogo className="h-8 w-8" />,
  },
  [kExternalStorageProvider.DROPBOX]: {
    label: kExternalStorageProviderDisplayName[kExternalStorageProvider.DROPBOX],
    icon: <DropboxLogo className="h-[30px] w-[33px] shrink-0" />,
    modalIcon: <DropboxLogo className="h-8 w-8" />,
  },
  [kExternalStorageProvider.BOX]: {
    label: kExternalStorageProviderDisplayName[kExternalStorageProvider.BOX],
    icon: <BoxLogo className="h-[30px] w-[33px] shrink-0" />,
    modalIcon: <BoxLogo className="h-8 w-8" />,
  },
  [kExternalStorageProvider.ONEDRIVE]: {
    label: kExternalStorageProviderDisplayName[kExternalStorageProvider.ONEDRIVE],
    icon: <OneDriveLogo className="h-[30px] w-[33px] shrink-0" />,
    modalIcon: <OneDriveLogo className="h-8 w-8" />,
  },
}
